module.exports = __webpack_public_path__ + "static/img/error.6b6aa43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error.jpg
// module id = aedp
// module chunks = 11